<template>
        <div>
            <course></course>
            <course-leg></course-leg>
            
        

            <elevation></elevation>
            <elevation-featured></elevation-featured>
            <kms></kms>
            <checkpoints></checkpoints> 

            <template v-if="$store.getters.openPlanejamento" v-for="item in $store.getters.trechosRunnersObject">
                <course-planejamento v-if="item.runner" :trecho="item.trecho" :runner="item.runner" :key="'course'+item.trecho.properties.numero+item.runner.id">
                </course-planejamento>

                <label-planejamento v-if="item.runner" :trecho="item.trecho" :runner="item.runner" :key="'label'+item.trecho.properties.numero+item.runner.id">
                </label-planejamento>
            </template>
        </div>
</template>

<script>

    export default{

        data(){
            return {
                loaded:false,
                geoJSON:false,
                kms_geoJSON:false,
                lastKmFlyedTo:0
            }
        },

        computed:{
            currentCourseLeg:function(){
                return this.$store.getters.currentCourseLeg;
            },
            map:function(){
                var parent = this.$parent;
                while(parent){
                    if(_.hasIn(parent,'map')){
                        return parent.map;
                        break;
                    }
                    parent = parent.$parent
                }
                return false;
            }
        },


        created:function(){
            this.$store.dispatch('loadPercurso');
           
            window.UIEvents.$on("elevationHover",({distance,elevation})=>{
                    //get the lat and lng of the current km
                     var point = this.$store.getters.pointFromDistance(distance);
                     console.log(point);
                     var center = [point.geometry.coordinates[0],point.geometry.coordinates[1]];
                     this.map.easeTo({center:center,duration:100})
            });

          

        },
        
        methods:{
        
        },


    }


</script>